// 合作伙伴主数据API
export default {
  // 人员主数据列表
  LIST_PERSONNEL: '/maindata/person/listPersonByPage',
  // 查询详情
  LIST_PERSONNEL_SEARCH: '/maindata/person/getPerson',
  //创建接口
  PERSONNEL_SAVEPERSON: '/maindata/person/savePerson',
  //启用禁用
  PERSONNEL_DISABLEORENTABLE: '/maindata/person/openOrClosePerson',
  //上传图片接口
  PERSONNEL_UPLOADSHOW: '/maindata/person/uploadShow',
  //修改接口
  PERSONNEL_UPDATEPERSON: '/maindata/person/updatePerson',
  //身份证校验
  PERSONNEL_CHECKPERSONID: '/maindata/person/checkPersonId',
  //字典表
  LISTDATA_DICTBYDATACODE: '/maindata/dictData/listDataDictByDataType',
  //导出接口
  LISTDATA_EXPORTPERSON: '/maindata/person/exportPerson',
  // 查询公司
  LISTDATA_SERECHCOMPANY: '/maindata/company/listCompanyByTenantCode',
  // 查询公司树
  LISTDATA_SERECHCOMPANYTREE: '/maindata/company/listCompanyOneDepartmentTree',
  // 查询部门
  LISTDATA_SERECHDEPARTMENT: '/maindata/department/listDepartmentByCompanyCode',
  //导入
  LISTDATA_IMPORTPERSONEXCEL: '/maindata/person/importPersonExcel',
  //放弃
  UPDATE_PERSON_FOR_GIVE_UP: '/maindata/person/updatePersonForGiveUp',
  //审批通过 驳回
  UPDATE_IS_REJECT: '/maindata/person/batchApprovalPerson',
  // 给admin临时更新
  UPDATE_DEPARTMENT: '/maindata/person/updatePersonCompanyDepartment',
};
